import { Attendance } from "@/api/openapi";
import { clsx } from "clsx/lite";
import { useNavigate } from "react-router-dom";
import { useAttendanceMobileElement } from "./attendanceMobileElement/useAttendanceMobileElement";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDot } from "@fortawesome/pro-solid-svg-icons";
import { faComment, faReceipt } from "@fortawesome/pro-regular-svg-icons";
import { formatHours } from "../attendanceUtils";

type AttendanceMobileElementProps = {
  attendance: Attendance;
};

export function AttendanceMobileElement({
  attendance,
}: AttendanceMobileElementProps) {
  const navigate = useNavigate();
  const {
    totalHours,
    totalActualHours,
    hasVoci,
    hasNote,
    selectedMonth,
    selectedYear,
  } = useAttendanceMobileElement({
    attendance,
  });

  return (
    <button
      onClick={() =>
        navigate(
          `/attendances/${attendance.employee.matricola}/${
            attendance.employee.filiale
          }/${selectedYear}/${selectedMonth}`,
        )
      }
      className="flex flex-row justify-between items-center w-full"
    >
      <div className="flex flex-col h-full justify-center items-start">
        <div className="font-medium">{attendance.employee.name}</div>
        <div className="text-font-secondary flex flex-row items-center">
          <div>{attendance.employee.matricola}</div>
          {(hasVoci || hasNote) && (
            <FontAwesomeIcon icon={faDot} className="text-xs" />
          )}
          {hasNote && (
            <FontAwesomeIcon icon={faComment} className="text-font-secondary" />
          )}
          {hasVoci && (
            <FontAwesomeIcon icon={faReceipt} className="text-font-secondary" />
          )}
          <div></div>
        </div>
      </div>

      <div
        className={clsx(
          "relative",
          "rounded-md",
          "flex",
          "flex-row",
          "px-2",
          "items-center",
          "gap-0.5",
          "bg-canvas-secondary",
          "h-8",
          "w-fit",
          "font-medium",
        )}
      >
        <div>{`${formatHours(totalActualHours)}h`}</div>
        <div className="text-font-secondary text-xs mt-2">
          {`/${totalHours}h`}
        </div>
      </div>
    </button>
  );
}
